import { render } from "./DpMainCategoryRow.vue?vue&type=template&id=46c53d6c&ts=true"
import script from "./DpMainCategoryRow.vue?vue&type=script&lang=ts"
export * from "./DpMainCategoryRow.vue?vue&type=script&lang=ts"

import "./DpMainCategoryRow.vue?vue&type=style&index=0&id=46c53d6c&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__